import { useTranslation } from 'react-i18next';
import FormItem from 'components/form/FormItem';
import { Input } from 'antd';
import { Control } from 'react-hook-form';

type Props = {
	/**
	 * optional - If not provided the translation key will be transformed using the section after the last . Example
	 *
	 * if 'createAchievementPage.apiName' was the key the name would be 'apiName'
	 */
	name?: string;
	control: Control<any>;
	/**
	 * This is the base translation key. Example:
	 *
	 *	'createAchievementPage.apiName'
		*
		* In the translation file then the following would be expected
		*
		* createAchievementPage: {
		*
		*	apiName: {

			label: 'API name',

			placeholder: 'Name of the achievement',

			hint: 'The name of the achievement that is used within the project code.'

		},

		}
		*
		*/
	translationKey: string;
	type?: string;
	disable?: boolean;
};

export function GetName(
	translationKey: string,
	name: string | undefined = undefined,
) {
	if (name === undefined) {
		const parts = translationKey.split('.');
		name = parts[parts.length - 1];
	}
	return name;
}

export default function FormInput(props: Props) {
	const { t } = useTranslation();
	var type = props.type;
	if (props.type == undefined) {
		type = 'text';
	}

	return (
		<FormItem
			name={GetName(props.translationKey, props.name)}
			label={t(`${props.translationKey}.label`)}
			hint={t(`${props.translationKey}.hint`)}
			control={props.control}
			render={({ field }) => (
				<Input
					size="large"
					{...field}
					type={type}
					disabled={props.disable || false}
					placeholder={t(`${props.translationKey}.placeholder`)}
				/>
			)}
		/>
	);
}
